import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import PropTypes from "prop-types";
import { useSelector } from 'react-redux';
import { LoaderWrapper, LoaderContainer, Spinner } from '../slider/timeline-slider-components';
import Typography from '../../../common-components/Typography';
import vmTheme from '../../../constants/theme';
import { font } from '../../../constants/font';
import content from '../../../constants/content';
import { TimelineScrollContext } from '../contexts/timeline-scroll-context';

const CONTAINER_WIDTH = 200;
const OFFSET = 14;

const CleaningAudioLoader = ({ sliderPlot, timelinePlotWidth, isAudio }) => {
    const loaderRef = useRef(null);
    const theme = useSelector((state) => state.app.get("theme"));
    const timelineScroll = useContext(TimelineScrollContext);

    const [left, setLeft] = useState(0);

    useLayoutEffect(() => {
        const sliderPlotX2 = sliderPlot.x + sliderPlot.width;
        const visibleX1 = Math.max(sliderPlot.x, timelineScroll.x);
        // Initial position
        let menuLeft = visibleX1 + OFFSET;
        // Ensure menuLeft stays within bounds
        menuLeft = Math.min(menuLeft, sliderPlotX2 - CONTAINER_WIDTH - OFFSET); // Stop at right limit
        menuLeft = Math.max(menuLeft, sliderPlot.x + OFFSET); // Stop at left limit

        setLeft(menuLeft - sliderPlot.x);
    }, [sliderPlot.width, sliderPlot.x, timelinePlotWidth, timelineScroll.x]);


    return (
        <LoaderWrapper isTransparent={isAudio}>
            <LoaderContainer ref={loaderRef} width={CONTAINER_WIDTH} left={left}>
                <Spinner isAudio={isAudio} />
                <Typography
                    content={content.CLEANING_AUDIO}
                    color={isAudio ? vmTheme[theme].celebrationViolet : vmTheme[theme].polarColor}
                    font={isAudio ? font.boldMicro : font.normalMiniBase}
                    padding={"2px 0px"}
                />
            </LoaderContainer>
        </LoaderWrapper>
    )
}

CleaningAudioLoader.propTypes = {
    sliderPlot: PropTypes.object,
    timelinePlotWidth: PropTypes.number,
    isAudio: PropTypes.bool,
};

export default CleaningAudioLoader;